import { motion } from 'framer-motion';

const container = {
	hidden: { opacity: 0 },
	visible: {
		opacity: 1,
		transition: {
			staggerChildren: 0.05,
			delayChildren: 0.5,
		},
	},
};

const letter = {
	hidden: { opacity: 0, y: '-50%' },
	visible: { opacity: 1, y: 0 },
};

export default function TextReveal({ text }: { text: string }) {
	return (
		<div className="relative inline-flex h-48 items-center overflow-hidden rounded-md">
			<motion.div
				initial={{ width: '0%' }}
				animate={{ width: '100%' }}
				transition={{ duration: 0.8, delay: 0.3 }}
				className="absolute left-0 top-1/2 h-full -translate-y-1/2 bg-secondary"
			/>

			<motion.div
				variants={container}
				initial="hidden"
				animate="visible"
				className="relative z-10 px-4 text-center text-6xl uppercase text-primary"
			>
				{text.split('').map((char, i) => (
					<motion.span key={i} variants={letter} className="font-extrabold">
						{char === ' ' ? '\u00A0' : char}
					</motion.span>
				))}
			</motion.div>
		</div>
	);
}
